import React from 'react';
import {CustomStyleDaySelector} from "./Styles";
import {Box} from "@mui/material";
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 *
 * CustomDayCheckbox is a reusable checkbox component for selecting days.
 * It supports a readonly mode with custom styling and validation for empty selections.
 *
 * @component
 *
 * @param {number} value - The value of the checkbox (required)
 * @param {string} label - The label to display next to the checkbox (required)
 * @param {boolean} checked - Whether the checkbox is checked (required)
 * @param {function} onChange - Event handler triggered when the checkbox value changes (required)
 * @param {string} id - The HTML id attribute for the checkbox (required)
 * @param {boolean} [emptyFields=false] - Indicates if the field is empty to display error styling
 * @param {boolean} [readonly=false] - If true, disables interactions and applies readonly styles
 * @param {string} [readonlyBorderColor] - Border color to use in readonly mode
 * @param {string} [readonlyCheckedColor] - Checked color to use in readonly mode
 * @param {string} [readonlyBackgroundColor] - Background color to use in readonly mode
 * @param {string} [readonlyTextColor] - Text color to use in readonly mode
 *
 * @returns {JSX.Element} The rendered checkbox component
 *
 * @example
 * <CustomDayCheckbox
 *   value={1}
 *   label="Monday"
 *   checked={dayArray.includes(1)}
 *   onChange={(e) => handleDay(e, 1)}
 *   id="day_1"
 *   emptyFields={dayArray.length === 0}
 *   readonly={true}
 *   readonlyBorderColor="#999"
 *   readonlyCheckedColor="#666"
 *   readonlyBackgroundColor="#f0f0f0"
 *   readonlyTextColor="#333"
 * />
 */
const CustomDayCheckbox = ({ value, label, checked, onChange, id, emptyFields, readonly, readonlyBorderColor, readonlyCheckedColor, readonlyBackgroundColor, readonlyTextColor}) => {

    return (<Box  sx={readonly ?
            CustomStyleDaySelector(
                {border: readonlyBorderColor, checked:readonlyCheckedColor, background:readonlyBackgroundColor, text: readonlyTextColor})
            : undefined}>
        <span className='days-text-style' >{label}</span>
        <Box className={"checkbox-container " + (emptyFields ? "error-container": "")}>
            <article className={emptyFields ? "error-article": ""}>
                <input type='checkbox' value={value} onChange={onChange} checked={checked} id={id} disabled={readonly}/>
            </article>
        </Box>
    </Box>
    );
};

export default CustomDayCheckbox;
